import { render, staticRenderFns } from "./JobUpdate.vue?vue&type=template&id=244fa6ed&"
import script from "../../../services/admin/job/job-update.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-update.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports